"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsAgentsAreaInsightsAttribute$ = exports.StatsAgentsAreaInsightsAttribute$outboundSchema = exports.StatsAgentsAreaInsightsAttribute$inboundSchema = void 0;
exports.statsAgentsAreaInsightsAttributeToJSON = statsAgentsAreaInsightsAttributeToJSON;
exports.statsAgentsAreaInsightsAttributeFromJSON = statsAgentsAreaInsightsAttributeFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const marketstatsattribute_js_1 = require("./marketstatsattribute.js");
/** @internal */
exports.StatsAgentsAreaInsightsAttribute$inboundSchema = z.object({
    agent_id: z.string(),
    agent_name: z.nullable(z.string()),
    lettings_statistics: z.nullable(marketstatsattribute_js_1.MarketStatsAttribute$inboundSchema),
    overall_statistics: z.nullable(marketstatsattribute_js_1.MarketStatsAttribute$inboundSchema),
    sales_statistics: z.nullable(marketstatsattribute_js_1.MarketStatsAttribute$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "agent_id": "agentId",
        "agent_name": "agentName",
        "lettings_statistics": "lettingsStatistics",
        "overall_statistics": "overallStatistics",
        "sales_statistics": "salesStatistics",
    });
});
/** @internal */
exports.StatsAgentsAreaInsightsAttribute$outboundSchema = z.object({
    agentId: z.string(),
    agentName: z.nullable(z.string()),
    lettingsStatistics: z.nullable(marketstatsattribute_js_1.MarketStatsAttribute$outboundSchema),
    overallStatistics: z.nullable(marketstatsattribute_js_1.MarketStatsAttribute$outboundSchema),
    salesStatistics: z.nullable(marketstatsattribute_js_1.MarketStatsAttribute$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        agentId: "agent_id",
        agentName: "agent_name",
        lettingsStatistics: "lettings_statistics",
        overallStatistics: "overall_statistics",
        salesStatistics: "sales_statistics",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var StatsAgentsAreaInsightsAttribute$;
(function (StatsAgentsAreaInsightsAttribute$) {
    /** @deprecated use `StatsAgentsAreaInsightsAttribute$inboundSchema` instead. */
    StatsAgentsAreaInsightsAttribute$.inboundSchema = exports.StatsAgentsAreaInsightsAttribute$inboundSchema;
    /** @deprecated use `StatsAgentsAreaInsightsAttribute$outboundSchema` instead. */
    StatsAgentsAreaInsightsAttribute$.outboundSchema = exports.StatsAgentsAreaInsightsAttribute$outboundSchema;
})(StatsAgentsAreaInsightsAttribute$ || (exports.StatsAgentsAreaInsightsAttribute$ = StatsAgentsAreaInsightsAttribute$ = {}));
function statsAgentsAreaInsightsAttributeToJSON(statsAgentsAreaInsightsAttribute) {
    return JSON.stringify(exports.StatsAgentsAreaInsightsAttribute$outboundSchema.parse(statsAgentsAreaInsightsAttribute));
}
function statsAgentsAreaInsightsAttributeFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.StatsAgentsAreaInsightsAttribute$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'StatsAgentsAreaInsightsAttribute' from JSON`);
}
//# sourceMappingURL=statsagentsareainsightsattribute.js.map